import { render, staticRenderFns } from "./OrganizationalUnitSponsor.vue?vue&type=template&id=39b26f78&"
import script from "./OrganizationalUnitSponsor.vue?vue&type=script&lang=js&"
export * from "./OrganizationalUnitSponsor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39b26f78')) {
      api.createRecord('39b26f78', component.options)
    } else {
      api.reload('39b26f78', component.options)
    }
    module.hot.accept("./OrganizationalUnitSponsor.vue?vue&type=template&id=39b26f78&", function () {
      api.rerender('39b26f78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/OrganizationalUnitSponsor.vue"
export default component.exports